import React from 'react'

const ArrowFaq = () => {
  return (
    <svg viewBox="22 25 20 14">
      <path fill="#E81C69" d="M34.8,39c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l4.4-4.3H23c-0.6,0-1-0.4-1-1s0.4-1,1-1h15.5l-4.4-4.3
	c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l6.2,6c0,0,0,0,0,0c0,0,0,0,0,0v0c0.2,0.2,0.3,0.4,0.3,0.7s-0.1,0.5-0.3,0.7v0
	c0,0,0,0,0,0c0,0,0,0,0,0l-6.2,6C35.3,38.9,35,39,34.8,39z"/>
    </svg>
  )
}

export default ArrowFaq
